<template>
  <section>
    <div class="footer-buttons py-2 px-4">
      <div class="d-flex justify-content-between">
        <div class="text-center">
          <div class="textBtn"><router-link to="/gallery" class="fontsize-large bg-none text-color-444 weight-light">گالری</router-link ></div>
        </div>
        <button class="footer-btn1" @click="openCloseMenu()">
          <div class="footer-btn-content">
            <MenuBtn></MenuBtn>
          </div>
        </button>
        <div class="text-center">
          <div class="textBtn"><router-link to="/weblogs" class="fontsize-large bg-none text-color-444 weight-light">مقالات</router-link></div>
        </div>
      </div>
    </div>
    <section class="menu-content d-flex justify-content-center align-items-end">
      <div class="menu-content-dt d-flex flex-column justify-content-between text-center">
        <div class="menu-content-logo mx-auto"><a @click="showRoute('/')"><img src="@/assets/images/logos/logoBlack.png" alt=""></a></div>
        <div>
          <ul>
            <li><a @click="showRoute('/weblogs')" class="fontsize-large weight-light text-color-444">وبلاگ</a></li>
            <li><a @click="showRoute('/about-us')" class="fontsize-large weight-light text-color-444">درباره ما</a></li>
            <li><a @click="showRoute('/contact')" class="fontsize-large weight-light text-color-444">تماس با ما</a></li>
          </ul>
          <div><a @click="showRoute('/partners')" class="partners-panel-btn fontsize-small py-1 px-3 mb-3 rounded-pill">پنل همکاران</a></div>
          <div>
            <button style="margin-top: 10px;" v-if="homeData" type="button" class="bg-none">
              <span class="fontsize-large weight-light text-color-444 ml-2">{{homeData.settings.site_phone_header}}</span>
              <svg class="icon" width="18" height="18" stroke="#444"><use href="@/assets/svgIcons/svgIcons.svg/#phone"></use></svg>
            </button>
          </div>
        </div>

      </div>

    </section>
    <div class="back-menu" @click="openCloseMenu()"></div>
  </section>
</template>

<script>
import MenuBtn from "./MenuBtn";
export default {
  name: "FooterButtons",
  components:{
    MenuBtn
  },
  data(){
    return{

        services:['طراحی وبسایت','سئو','طراحی اپلیکیشن','تولید نرم افزار ','مشاوره و بازار یابی','راه اندازی استارتاپ'],

    }
  },
  computed: {
    homeData(){
      return this.$root.homeData;
    }
  },
  methods:{
    showRoute(router){
      this.openCloseMenu();
      this.$router.push(router)

    },
    openCloseMenu(){
      // document.querySelector('.footer-btn1').classList.toggle('rotate90');
      // document.querySelector('.footer-btn2').classList.toggle('TScale1');
      document.querySelector('.menu-content .menu-content-dt').classList.toggle('scaleY1');
      document.querySelector('.menu-content').classList.toggle('scaleY1');
      document.querySelector('.resp-menu-btn').classList.toggle('close-btn')
      setTimeout( function (){
        document.querySelector('.back-menu').classList.toggle('scaleY1');
          }
    , 200)
    }
  }
}
</script>

<style scoped>
.footer-buttons{
  background-color: white;
  box-shadow: 0 0 5px #0009;
  border-radius: 20px ;
  position: fixed;
  right: 2rem;
  bottom: 8px;
  left: 2rem;
  z-index: 900;
}
.footer-buttons>div{
  padding-right: 1rem;
  padding-left: 1rem;
}
.footer-btn1{
  width: 70px;
  height: 70px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: .75s;
  transform-origin: top;
  /*background: #18163c;*/
  background-image: radial-gradient( #30504F,#30504F,#000);
  bottom: 0;

}
.footer-btn1 img{
  width: 100%;
}

.footer-btn-content{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
}

.rotate90{
  transform:rotateX(90deg) translateX(-50%);
  top: 0;
}
.TScale1{
  transform: translateX(-50%) scaleY(1);

}
.menu-content{
  position: fixed;
  top: 1rem;
  right: 1rem;
  left: 1rem;
  bottom: 8px;
  z-index: 899;
  transform: scaleY(0);
  transition: 1s;
  transform-origin: bottom;
  background-color: #fffe;
  box-shadow: 0 0 5px #0003;
  border-radius: 30px;
}
.back-menu{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0px;
  z-index: 898;
  /*background-color: #fff7;*/
  transform: scaleY(0);
  transition: 0s;
  transform-origin: bottom;
}
.menu-content .menu-content-dt{
  height: 75%;
  transform-origin: bottom;
  transform: scaleY(0);
  transition: 1s;
  margin-bottom: 80px;
}
.scaleY1{
  transform: scaleY(1) !important;
}
.menu-content ul{
  list-style-type: none;
}
.menu-content ul li{
  position: relative;
}

.menu-content ul a {
  padding: .5rem 1rem;
  display: block;
  color: #222;
}
.menu-content-logo{
  width: 50%;
}
.menu-content-logo img{
  width: 100%;
}
.menu-content-dt .partners-panel-btn{
  box-shadow: 0 0 5px #0003 , 0 0 5px #0003 inset;
  color: white;
  background-color: var(--color-theme);
  width: 80%;
}
@media screen and (max-width: 380px) {
  .menu-content .menu-content-dt{
    width: 300px;
  }
  .menu-content-dt .partners-panel-btn{
    width: 50%;
  }
}
@media screen and (max-width: 330px) {
  .menu-content .menu-content-dt{
    width: 250px;
  }
  .rotate90{
    top: 0;
  }

}
@media screen and (max-width: 300px) {
  .footer-buttons.px-4{
    padding-right:1rem !important;
    padding-left:1rem !important;
  }
  .footer-buttons>div{
    padding-right: 0;
    padding-left: 0;
  }
  .footer-btn1 {
    width: 60px;
    height: 60px;
  }
}
</style>